import type { IFolder } from "@/types/folder";

import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useFolderActions } from "@/components/folderDropdown/useFolderActions";
import BottomSheet from "@/components/ui/bottomSheet";

interface IFolderOptionsSheetProps {
  folder: IFolder;
  show: boolean;
  onHide: () => void;
}

function FolderOptionsSheet({
  folder,
  show,
  onHide,
}: IFolderOptionsSheetProps) {
  const { t } = useTranslation();
  const { items, deleteItem, modals } = useFolderActions(folder, "sheet");

  return (
    <>
      <BottomSheet
        show={show}
        onHide={onHide}
        title={t("page.myQrCodes.folderOptions")}
        content={
          <div className="list-group list-group-flush">
            {items.map(({ icon, label, onClick, disabled }) => (
              <Button
                key={label}
                type="button"
                onClick={() => {
                  onClick();
                  onHide();
                }}
                disabled={disabled}
                className="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3 border-0 border-bottom"
              >
                {icon}
                {label}
              </Button>
            ))}
            <Button
              type="button"
              onClick={() => {
                deleteItem.onClick();
                onHide();
              }}
              disabled={deleteItem.disabled}
              className="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3 border-0 text-danger"
            >
              {deleteItem.icon}
              {deleteItem.label}
            </Button>
          </div>
        }
      />
      {modals}
    </>
  );
}

export default FolderOptionsSheet;
